<!-- <div class="main">
    <h3>A Step-by-Step Guide</h3>
    <h2>Empowering the Next Generation of Executive Coaches</h2>
    <p>
        Whether you're looking to become a certified Executive Coach, start your own practice, or advance in leadership, 
        our intensive programs provide the expertise, certification, and confidence to succeed.
    </p>

    <div class="contant">
        <div class="cards" *ngFor="let item of cards">
    <div>
        <img [src]="item.img" alt="{{ item.heading }}">
    </div>
    <h5>{{ item.heading }}</h5>
    <p>{{ item.para }}</p>
    
    <ng-container *ngIf="item.route">
        <button [routerLink]="item.route">{{ item.button }}</button>
    </ng-container>

   <ng-container *ngIf="item.videoLink">
  <button (click)="openVideoPopup(item)">
    {{ item.button }}
  </button>
</ng-container>
</div>

        <div class="cards card2">
            <div>
                <img src="../../assets/landing/card4.png" alt="Start Your Journey">
            </div>
            <h5>Start Your Journey</h5>
            <p>Don’t wait — your future in Executive Coaching begins today!</p>
            <button routerLink="/program-page">Get Started</button>
        </div> 
    </div>
</div> -->

<!-- <app-vertual></app-vertual> -->



<!-- Video Popup Overlay -->
<div class="video-popup-overlay" *ngIf="showVideoPopup" (click)="closeVideoPopup()">
  <div class="video-popup-box" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeVideoPopup()">&times;</button>

    <!-- Video Player -->
    <iframe
      *ngIf="popupVideoUrl"
      [src]="popupVideoUrl"
      frameborder="0"
      allowfullscreen>
    </iframe>

    <!-- Tabs Section -->
    <div class="video-tabs">
      <button [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">Overview</button>
      <button [class.active]="activeTab === 'faq'" (click)="activeTab = 'faq'">Prerequisites & FAQs</button>
    </div>

    <div class="video-info" *ngIf="activeTab === 'overview'">
      <h2>{{ selectedVideo?.title }}</h2>
      <p>{{ selectedVideo?.description }}</p>
    </div>

    <div class="video-info" *ngIf="activeTab === 'faq'">
      <h3>Prerequisites & FAQs</h3>
      <p>Coming soon...</p>
    </div>
  </div>
</div>
